const ExecutiveDiagramFrame = ({ theme, children, caption, className = '' }) => {
  const isDark = theme === 'dark';

  return (
    <figure className={className}>
      <div
        className={`rounded-xl border overflow-hidden ${
          isDark ? 'border-slate-700/80 bg-slate-950' : 'border-slate-200 bg-slate-50'
        }`}
      >
        {children}
      </div>
      {caption && (
        <figcaption
          className={`mt-3 text-[11px] uppercase tracking-[0.2em] text-center ${
            isDark ? 'text-slate-500' : 'text-slate-400'
          }`}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default ExecutiveDiagramFrame;
